import {
  CampaignHeroLayout,
  CampaignHeroSlice,
} from '@adapters/prismic/types/brandedStorePage';
import { CampaignHeroData } from '_components/CampaignHero/types';
import { HeroCta, HeroLink } from '_components/HeroInfoCard/types';

const toLink = (label?: string | null, url?: string | null): HeroLink | null =>
  label?.trim() && url?.trim()
    ? { label: label.trim(), url: url.trim() }
    : null;

const mapCampaignHeroData = (
  primary: CampaignHeroSlice['primary']
): CampaignHeroData => {
  const desktopImage = primary.image?.url ? primary.image : null;
  const authoredMobileImage = primary.mobile_image?.url
    ? primary.mobile_image
    : null;
  const image = desktopImage ?? authoredMobileImage;
  const mobileImage =
    authoredMobileImage && authoredMobileImage.url !== image?.url
      ? authoredMobileImage
      : null;

  const isSideBySide =
    primary.layout === CampaignHeroLayout.sideBySide ||
    primary.layout === CampaignHeroLayout.sideBySideFlipped;
  const sideBySide = isSideBySide && !!image;

  const ctas = [
    toLink(primary.cta_1_label, primary.cta_1_link),
    toLink(primary.cta_2_label, primary.cta_2_link),
  ]
    .map((link, slot) => (link ? { ...link, slot } : null))
    .filter((cta): cta is HeroCta => cta !== null);

  const description = primary.info_card_description?.trim();
  const infoCardCta = toLink(
    primary.info_card_cta_label,
    primary.info_card_cta_link
  );

  return {
    h1: primary.title?.trim() ?? '',
    subheading: primary.subheading?.trim() || null,
    layout: sideBySide ? 'sideBySide' : 'centered',
    flipped:
      sideBySide && primary.layout === CampaignHeroLayout.sideBySideFlipped,
    image,
    mobileImage,
    ctas,
    infoCard:
      image && description && infoCardCta
        ? { description, cta: infoCardCta }
        : null,
  };
};

export default mapCampaignHeroData;
